import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { coerceIn10f36k81le1mm as coerceIn } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { toInt5qdj874w69jh as toInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  FloatSerializer_getInstance1c6yoefuaocts as FloatSerializer_getInstance,
  DoubleSerializer_getInstance1tuvibnyg07o1 as DoubleSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { _UInt___init__impl__l7qpdl5ip6p2ldulrs as _UInt___init__impl__l7qpdl } from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import { toString10m9tj9xt75j5 as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/UStrings.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { padStart36w1507hs626a as padStart } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { drop336950s126lmj as drop } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  Companion_getInstance3o2pcl1yhcf6p as Companion_getInstance,
  Angle36m0cdko0c63j as Angle,
  Angle__toString_impl_786qky378m8w1fbyftn as Angle__toString_impl_786qky,
  Angle__hashCode_impl_szcndt3896t4hbc70ye as Angle__hashCode_impl_szcndt,
} from './Angle.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { asSequence2phdjljfh9jhx as asSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  zipWithNext1coaflhq3atps as zipWithNext,
  sum21i2pabt6cxsw as sum,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function byteize($this, $receiver) {
  return coerceIn(numberToInt($receiver * 255), 0, 255);
}
function floatize($this, $receiver) {
  return coerceIn($receiver, 0, 255) / 255;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.WCAG_AA_NORMAL_TEXT_CONTRAST_RATIO_1 = 4.5;
        this.transparent_1 = new (Color())(0.0);
        this.white_1 = new (Color())(1.0, 1.0, 1.0, 1.0);
        this.gray_1 = new (Color())(1.0, 0.5, 0.5, 0.5);
        this.black_1 = new (Color())(1.0, 0.0, 0.0, 0.0);
        this.red_1 = new (Color())(1.0, 1.0, 0.0, 0.0);
        this.orange_1 = new (Color())(1.0, 1.0, 0.5, 0.0);
        this.yellow_1 = new (Color())(1.0, 1.0, 1.0, 0.0);
        this.green_1 = new (Color())(1.0, 0.0, 1.0, 0.0);
        this.teal_1 = new (Color())(1.0, 0.0, 1.0, 1.0);
        this.blue_1 = new (Color())(1.0, 0.0, 0.0, 1.0);
        this.purple_1 = new (Color())(1.0, 1.0, 0.0, 1.0);
      }
      gray_u3prp_k$(amount) {
        return new (Color())(1.0, amount, amount, amount);
      }
      fromHex_s0l3vd_k$(value) {
        return new (Color())(1.0, floatize(this, value >> 16 & 255), floatize(this, value >> 8 & 255), floatize(this, value & 255));
      }
      fromHexString_vb3go_k$(value) {
        return this.fromHex_s0l3vd_k$(toInt(replace(value, '#', ''), 16));
      }
      interpolate_s30y89_k$(left, right, ratio) {
        var invRatio = 1 - ratio;
        return new (Color())(left.alpha_1 * invRatio + right.alpha_1 * ratio, left.red_1 * invRatio + right.red_1 * ratio, left.green_1 * invRatio + right.green_1 * ratio, left.blue_1 * invRatio + right.blue_1 * ratio);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.kiteui.models.Color', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('alpha', true);
        tmp0_serialDesc.addElement_5pzumi_k$('red', true);
        tmp0_serialDesc.addElement_5pzumi_k$('green', true);
        tmp0_serialDesc.addElement_5pzumi_k$('blue', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_3wfdbw_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value.alpha_1, 1.0)) {
          tmp1_output.encodeFloatElement_oe8hn_k$(tmp0_desc, 0, value.alpha_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !equals(value.red_1, 0.0)) {
          tmp1_output.encodeFloatElement_oe8hn_k$(tmp0_desc, 1, value.red_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !equals(value.green_1, 0.0)) {
          tmp1_output.encodeFloatElement_oe8hn_k$(tmp0_desc, 2, value.green_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !equals(value.blue_1, 0.0)) {
          tmp1_output.encodeFloatElement_oe8hn_k$(tmp0_desc, 3, value.blue_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_3wfdbw_k$(encoder, value instanceof Color() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0.0;
        var tmp5_local1 = 0.0;
        var tmp6_local2 = 0.0;
        var tmp7_local3 = 0.0;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp8_input.decodeFloatElement_p2q55h_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeFloatElement_p2q55h_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.decodeFloatElement_p2q55h_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.decodeFloatElement_p2q55h_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.decodeFloatElement_p2q55h_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeFloatElement_p2q55h_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.decodeFloatElement_p2q55h_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.decodeFloatElement_p2q55h_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Color().new_com_lightningkite_kiteui_models_Color_pg5sji_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance(), FloatSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var ColorClass;
function Color() {
  if (ColorClass === VOID) {
    class $ {
      constructor(alpha, red, green, blue) {
        Companion_getInstance_0();
        alpha = alpha === VOID ? 1.0 : alpha;
        red = red === VOID ? 0.0 : red;
        green = green === VOID ? 0.0 : green;
        blue = blue === VOID ? 0.0 : blue;
        this.alpha_1 = alpha;
        this.red_1 = red;
        this.green_1 = green;
        this.blue_1 = blue;
      }
      map_p3tssl_k$(mapper) {
        // Inline function 'kotlin.let' call
        return mapper(this);
      }
      closestColor_akwbqu_k$() {
        return this;
      }
      applyAlpha_eeyl20_k$(alpha) {
        return this.copy$default_hrmb8q_k$(alpha * this.alpha_1);
      }
      toInt_1tsl84_k$() {
        return byteize(Companion_getInstance_0(), this.alpha_1) << 24 | byteize(Companion_getInstance_0(), this.red_1) << 16 | byteize(Companion_getInstance_0(), this.green_1) << 8 | byteize(Companion_getInstance_0(), this.blue_1);
      }
      get_average_96e6do_k$() {
        return (this.red_1 + this.green_1 + this.blue_1) / 3.0;
      }
      get_perceivedBrightness_8c130z_k$() {
        // Inline function 'kotlin.math.sqrt' call
        var x = this.red_1 * this.red_1 * 0.299 + this.green_1 * this.green_1 * 0.587 + this.blue_1 * this.blue_1 * 0.114;
        return Math.sqrt(x);
      }
      get_redInt_iy5nzb_k$() {
        return byteize(Companion_getInstance_0(), this.red_1);
      }
      get_greenInt_serb63_k$() {
        return byteize(Companion_getInstance_0(), this.green_1);
      }
      get_blueInt_103sy4_k$() {
        return byteize(Companion_getInstance_0(), this.blue_1);
      }
      toWhite_7ealyu_k$(ratio) {
        return Companion_getInstance_0().interpolate_s30y89_k$(this, Companion_getInstance_0().white_1, ratio);
      }
      toBlack_wq6kdw_k$(ratio) {
        return Companion_getInstance_0().interpolate_s30y89_k$(this, Companion_getInstance_0().black_1, ratio);
      }
      highlight_bst4u4_k$(ratio) {
        return this.get_average_96e6do_k$() > 0.5 ? this.toBlack_wq6kdw_k$(ratio) : this.toWhite_7ealyu_k$(ratio);
      }
      toWeb_1tsvdl_k$() {
        return 'rgba(' + this.get_redInt_iy5nzb_k$() + ', ' + this.get_greenInt_serb63_k$() + ', ' + this.get_blueInt_103sy4_k$() + ', ' + this.alpha_1 + ')';
      }
      toAlphalessWeb_15mha0_k$() {
        // Inline function 'kotlin.toUInt' call
        var this_0 = this.toInt_1tsl84_k$();
        var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
        return '#' + drop(padStart(toString_0(tmp$ret$0, 16), 8, _Char___init__impl__6a9atx(48)), 2);
      }
      copy_egrqb9_k$(alpha, red, green, blue) {
        return new (Color())(alpha, red, green, blue);
      }
      copy$default_hrmb8q_k$(alpha, red, green, blue, $super) {
        alpha = alpha === VOID ? this.alpha_1 : alpha;
        red = red === VOID ? this.red_1 : red;
        green = green === VOID ? this.green_1 : green;
        blue = blue === VOID ? this.blue_1 : blue;
        return $super === VOID ? this.copy_egrqb9_k$(alpha, red, green, blue) : $super.copy_egrqb9_k$.call(this, alpha, red, green, blue);
      }
      toString() {
        return 'Color(alpha=' + this.alpha_1 + ', red=' + this.red_1 + ', green=' + this.green_1 + ', blue=' + this.blue_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.alpha_1);
        result = imul(result, 31) + getNumberHashCode(this.red_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.green_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.blue_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Color()))
          return false;
        if (!equals(this.alpha_1, other.alpha_1))
          return false;
        if (!equals(this.red_1, other.red_1))
          return false;
        if (!equals(this.green_1, other.green_1))
          return false;
        if (!equals(this.blue_1, other.blue_1))
          return false;
        return true;
      }
      static new_com_lightningkite_kiteui_models_Color_pg5sji_k$(seen0, alpha, red, green, blue, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.alpha_1 = 1.0;
        else
          $this.alpha_1 = alpha;
        if (0 === (seen0 & 2))
          $this.red_1 = 0.0;
        else
          $this.red_1 = red;
        if (0 === (seen0 & 4))
          $this.green_1 = 0.0;
        else
          $this.green_1 = green;
        if (0 === (seen0 & 8))
          $this.blue_1 = 0.0;
        else
          $this.blue_1 = blue;
        return $this;
      }
    }
    initMetadataForClass($, 'Color', Color, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    ColorClass = $;
  }
  return ColorClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        // Inline function 'kotlin.collections.listOf' call
        var tmp$ret$0 = emptyList();
        tmp.INVALID_1 = new (LinearGradient())(tmp$ret$0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
function LinearGradient$closestColor$lambda(a, b) {
  return (b.ratio_1 - a.ratio_1) * (a.color_1.alpha_1 + b.color_1.alpha_1) / 2;
}
function LinearGradient$closestColor$lambda_0(a, b) {
  return (b.ratio_1 - a.ratio_1) * (a.color_1.red_1 + b.color_1.red_1) / 2;
}
function LinearGradient$closestColor$lambda_1(a, b) {
  return (b.ratio_1 - a.ratio_1) * (a.color_1.green_1 + b.color_1.green_1) / 2;
}
function LinearGradient$closestColor$lambda_2(a, b) {
  return (b.ratio_1 - a.ratio_1) * (a.color_1.blue_1 + b.color_1.blue_1) / 2;
}
var LinearGradientClass;
function LinearGradient() {
  if (LinearGradientClass === VOID) {
    class $ {
      constructor(stops, angle, screenStatic, x0, y0, x1, y1) {
        Companion_getInstance_1();
        angle = angle === VOID ? Companion_getInstance().zero_1 : angle;
        screenStatic = screenStatic === VOID ? false : screenStatic;
        x0 = x0 === VOID ? null : x0;
        y0 = y0 === VOID ? null : y0;
        x1 = x1 === VOID ? null : x1;
        y1 = y1 === VOID ? null : y1;
        this.stops_1 = stops;
        this.angle_1 = angle;
        this.screenStatic_1 = screenStatic;
        this.x0__1 = x0;
        this.y0__1 = y0;
        this.x1__1 = x1;
        this.y1__1 = y1;
      }
      map_p3tssl_k$(mapper) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.stops_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.let' call
          var tmp$ret$3 = mapper(item.color_1);
          var tmp$ret$2 = item.copy$default_kttyy5_k$(VOID, tmp$ret$3);
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        return this.copy$default_ufhiwj_k$(destination);
      }
      closestColor_akwbqu_k$() {
        if (this.stops_1.isEmpty_y1axqb_k$())
          return Companion_getInstance_0().transparent_1;
        if (this.stops_1.get_size_woubt6_k$() === 1)
          return this.stops_1.get_c1px32_k$(0).color_1;
        var tmp = asSequence(this.stops_1);
        var tmp_0 = sum(zipWithNext(tmp, LinearGradient$closestColor$lambda));
        var tmp_1 = asSequence(this.stops_1);
        var tmp_2 = sum(zipWithNext(tmp_1, LinearGradient$closestColor$lambda_0));
        var tmp_3 = asSequence(this.stops_1);
        var tmp_4 = sum(zipWithNext(tmp_3, LinearGradient$closestColor$lambda_1));
        var tmp_5 = asSequence(this.stops_1);
        return new (Color())(tmp_0, tmp_2, tmp_4, sum(zipWithNext(tmp_5, LinearGradient$closestColor$lambda_2)));
      }
      copy_9vo3f5_k$(stops, angle, screenStatic, x0, y0, x1, y1) {
        return new (LinearGradient())(stops, angle, screenStatic, x0, y0, x1, y1);
      }
      copy$default_ufhiwj_k$(stops, angle, screenStatic, x0, y0, x1, y1, $super) {
        stops = stops === VOID ? this.stops_1 : stops;
        angle = angle === VOID ? this.angle_1 : angle;
        screenStatic = screenStatic === VOID ? this.screenStatic_1 : screenStatic;
        x0 = x0 === VOID ? this.x0__1 : x0;
        y0 = y0 === VOID ? this.y0__1 : y0;
        x1 = x1 === VOID ? this.x1__1 : x1;
        y1 = y1 === VOID ? this.y1__1 : y1;
        return $super === VOID ? this.copy_9vo3f5_k$(stops, angle, screenStatic, x0, y0, x1, y1) : $super.copy_9vo3f5_k$.call(this, stops, new (Angle())(angle), screenStatic, x0, y0, x1, y1);
      }
      toString() {
        return 'LinearGradient(stops=' + toString(this.stops_1) + ', angle=' + Angle__toString_impl_786qky(this.angle_1) + ', screenStatic=' + this.screenStatic_1 + ', x0=' + this.x0__1 + ', y0=' + this.y0__1 + ', x1=' + this.x1__1 + ', y1=' + this.y1__1 + ')';
      }
      hashCode() {
        var result = hashCode(this.stops_1);
        result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.angle_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.screenStatic_1) | 0;
        result = imul(result, 31) + (this.x0__1 == null ? 0 : getNumberHashCode(this.x0__1)) | 0;
        result = imul(result, 31) + (this.y0__1 == null ? 0 : getNumberHashCode(this.y0__1)) | 0;
        result = imul(result, 31) + (this.x1__1 == null ? 0 : getNumberHashCode(this.x1__1)) | 0;
        result = imul(result, 31) + (this.y1__1 == null ? 0 : getNumberHashCode(this.y1__1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LinearGradient()))
          return false;
        if (!equals(this.stops_1, other.stops_1))
          return false;
        if (!equals(this.angle_1, other.angle_1))
          return false;
        if (!(this.screenStatic_1 === other.screenStatic_1))
          return false;
        if (!equals(this.x0__1, other.x0__1))
          return false;
        if (!equals(this.y0__1, other.y0__1))
          return false;
        if (!equals(this.x1__1, other.x1__1))
          return false;
        if (!equals(this.y1__1, other.y1__1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'LinearGradient');
    LinearGradientClass = $;
  }
  return LinearGradientClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.kiteui.models.GradientStop', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('ratio', false);
        tmp0_serialDesc.addElement_5pzumi_k$('color', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_yf1f2_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeFloatElement_oe8hn_k$(tmp0_desc, 0, value.ratio_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance(), value.color_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_yf1f2_k$(encoder, value instanceof GradientStop() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0.0;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeFloatElement_p2q55h_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeFloatElement_p2q55h_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return GradientStop().new_com_lightningkite_kiteui_models_GradientStop_6gmoit_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [FloatSerializer_getInstance(), $serializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var GradientStopClass;
function GradientStop() {
  if (GradientStopClass === VOID) {
    class $ {
      constructor(ratio, color) {
        this.ratio_1 = ratio;
        this.color_1 = color;
      }
      copy_1f6e1i_k$(ratio, color) {
        return new (GradientStop())(ratio, color);
      }
      copy$default_kttyy5_k$(ratio, color, $super) {
        ratio = ratio === VOID ? this.ratio_1 : ratio;
        color = color === VOID ? this.color_1 : color;
        return $super === VOID ? this.copy_1f6e1i_k$(ratio, color) : $super.copy_1f6e1i_k$.call(this, ratio, color);
      }
      toString() {
        return 'GradientStop(ratio=' + this.ratio_1 + ', color=' + this.color_1.toString() + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.ratio_1);
        result = imul(result, 31) + this.color_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GradientStop()))
          return false;
        if (!equals(this.ratio_1, other.ratio_1))
          return false;
        if (!this.color_1.equals(other.color_1))
          return false;
        return true;
      }
      static new_com_lightningkite_kiteui_models_GradientStop_6gmoit_k$(seen0, ratio, color, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_0().descriptor_1);
        }
        var $this = createThis(this);
        $this.ratio_1 = ratio;
        $this.color_1 = color;
        return $this;
      }
    }
    initMetadataForClass($, 'GradientStop', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    GradientStopClass = $;
  }
  return GradientStopClass;
}
function applyAlpha(_this__u8e3s4, alpha) {
  return _this__u8e3s4.map_p3tssl_k$((it) => it.applyAlpha_eeyl20_k$(alpha));
}
function RadialGradient$Companion$$childSerializers$_anonymous__bstz97() {
  return new (ArrayListSerializer())($serializer_getInstance_0());
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [lazy(tmp_0, RadialGradient$Companion$$childSerializers$_anonymous__bstz97), null, null, null, null, null, null];
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_3() {
  if (Companion_instance_2 === VOID)
    new (Companion_2())();
  return Companion_instance_2;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.kiteui.models.RadialGradient', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('stops', false);
        tmp0_serialDesc.addElement_5pzumi_k$('screenStatic', true);
        tmp0_serialDesc.addElement_5pzumi_k$('cx', true);
        tmp0_serialDesc.addElement_5pzumi_k$('cy', true);
        tmp0_serialDesc.addElement_5pzumi_k$('radius', true);
        tmp0_serialDesc.addElement_5pzumi_k$('fx', true);
        tmp0_serialDesc.addElement_5pzumi_k$('fy', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_dpvm32_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_3().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, tmp2_cached[0].get_value_j01efc_k$(), value.stops_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.screenStatic_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 1, value.screenStatic_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.cx_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, DoubleSerializer_getInstance(), value.cx_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.cy_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, DoubleSerializer_getInstance(), value.cy_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !(value.radius_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, DoubleSerializer_getInstance(), value.radius_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.fx_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, DoubleSerializer_getInstance(), value.fx_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.fy_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, DoubleSerializer_getInstance(), value.fy_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_dpvm32_k$(encoder, value instanceof RadialGradient() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp12_cached = Companion_getInstance_3().$childSerializers_1;
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp12_cached[0].get_value_j01efc_k$(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, DoubleSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, DoubleSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, DoubleSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, DoubleSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, DoubleSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp12_cached[0].get_value_j01efc_k$(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, DoubleSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, DoubleSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, DoubleSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, DoubleSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, DoubleSerializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return RadialGradient().new_com_lightningkite_kiteui_models_RadialGradient_ot2p40_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_3().$childSerializers_1[0].get_value_j01efc_k$(), BooleanSerializer_getInstance(), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance()), get_nullable(DoubleSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
function RadialGradient$closestColor$lambda(a, b) {
  return (b.ratio_1 - a.ratio_1) * (a.color_1.alpha_1 + b.color_1.alpha_1) / 2;
}
function RadialGradient$closestColor$lambda_0(a, b) {
  return (b.ratio_1 - a.ratio_1) * (a.color_1.red_1 + b.color_1.red_1) / 2;
}
function RadialGradient$closestColor$lambda_1(a, b) {
  return (b.ratio_1 - a.ratio_1) * (a.color_1.green_1 + b.color_1.green_1) / 2;
}
function RadialGradient$closestColor$lambda_2(a, b) {
  return (b.ratio_1 - a.ratio_1) * (a.color_1.blue_1 + b.color_1.blue_1) / 2;
}
var RadialGradientClass;
function RadialGradient() {
  if (RadialGradientClass === VOID) {
    class $ {
      constructor(stops, screenStatic, cx, cy, radius, fx, fy) {
        Companion_getInstance_3();
        screenStatic = screenStatic === VOID ? false : screenStatic;
        cx = cx === VOID ? null : cx;
        cy = cy === VOID ? null : cy;
        radius = radius === VOID ? null : radius;
        fx = fx === VOID ? null : fx;
        fy = fy === VOID ? null : fy;
        this.stops_1 = stops;
        this.screenStatic_1 = screenStatic;
        this.cx_1 = cx;
        this.cy_1 = cy;
        this.radius_1 = radius;
        this.fx_1 = fx;
        this.fy_1 = fy;
      }
      map_p3tssl_k$(mapper) {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.stops_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.let' call
          var tmp$ret$3 = mapper(item.color_1);
          var tmp$ret$2 = item.copy$default_kttyy5_k$(VOID, tmp$ret$3);
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        return this.copy$default_9u3boc_k$(destination);
      }
      closestColor_akwbqu_k$() {
        if (this.stops_1.isEmpty_y1axqb_k$())
          return Companion_getInstance_0().transparent_1;
        if (this.stops_1.get_size_woubt6_k$() === 1)
          return this.stops_1.get_c1px32_k$(0).color_1;
        var tmp = asSequence(this.stops_1);
        var tmp_0 = sum(zipWithNext(tmp, RadialGradient$closestColor$lambda));
        var tmp_1 = asSequence(this.stops_1);
        var tmp_2 = sum(zipWithNext(tmp_1, RadialGradient$closestColor$lambda_0));
        var tmp_3 = asSequence(this.stops_1);
        var tmp_4 = sum(zipWithNext(tmp_3, RadialGradient$closestColor$lambda_1));
        var tmp_5 = asSequence(this.stops_1);
        return new (Color())(tmp_0, tmp_2, tmp_4, sum(zipWithNext(tmp_5, RadialGradient$closestColor$lambda_2)));
      }
      copy_r4p4jq_k$(stops, screenStatic, cx, cy, radius, fx, fy) {
        return new (RadialGradient())(stops, screenStatic, cx, cy, radius, fx, fy);
      }
      copy$default_9u3boc_k$(stops, screenStatic, cx, cy, radius, fx, fy, $super) {
        stops = stops === VOID ? this.stops_1 : stops;
        screenStatic = screenStatic === VOID ? this.screenStatic_1 : screenStatic;
        cx = cx === VOID ? this.cx_1 : cx;
        cy = cy === VOID ? this.cy_1 : cy;
        radius = radius === VOID ? this.radius_1 : radius;
        fx = fx === VOID ? this.fx_1 : fx;
        fy = fy === VOID ? this.fy_1 : fy;
        return $super === VOID ? this.copy_r4p4jq_k$(stops, screenStatic, cx, cy, radius, fx, fy) : $super.copy_r4p4jq_k$.call(this, stops, screenStatic, cx, cy, radius, fx, fy);
      }
      toString() {
        return 'RadialGradient(stops=' + toString(this.stops_1) + ', screenStatic=' + this.screenStatic_1 + ', cx=' + this.cx_1 + ', cy=' + this.cy_1 + ', radius=' + this.radius_1 + ', fx=' + this.fx_1 + ', fy=' + this.fy_1 + ')';
      }
      hashCode() {
        var result = hashCode(this.stops_1);
        result = imul(result, 31) + getBooleanHashCode(this.screenStatic_1) | 0;
        result = imul(result, 31) + (this.cx_1 == null ? 0 : getNumberHashCode(this.cx_1)) | 0;
        result = imul(result, 31) + (this.cy_1 == null ? 0 : getNumberHashCode(this.cy_1)) | 0;
        result = imul(result, 31) + (this.radius_1 == null ? 0 : getNumberHashCode(this.radius_1)) | 0;
        result = imul(result, 31) + (this.fx_1 == null ? 0 : getNumberHashCode(this.fx_1)) | 0;
        result = imul(result, 31) + (this.fy_1 == null ? 0 : getNumberHashCode(this.fy_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RadialGradient()))
          return false;
        if (!equals(this.stops_1, other.stops_1))
          return false;
        if (!(this.screenStatic_1 === other.screenStatic_1))
          return false;
        if (!equals(this.cx_1, other.cx_1))
          return false;
        if (!equals(this.cy_1, other.cy_1))
          return false;
        if (!equals(this.radius_1, other.radius_1))
          return false;
        if (!equals(this.fx_1, other.fx_1))
          return false;
        if (!equals(this.fy_1, other.fy_1))
          return false;
        return true;
      }
      static new_com_lightningkite_kiteui_models_RadialGradient_ot2p40_k$(seen0, stops, screenStatic, cx, cy, radius, fx, fy, serializationConstructorMarker) {
        Companion_getInstance_3();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_1().descriptor_1);
        }
        var $this = createThis(this);
        $this.stops_1 = stops;
        if (0 === (seen0 & 2))
          $this.screenStatic_1 = false;
        else
          $this.screenStatic_1 = screenStatic;
        if (0 === (seen0 & 4))
          $this.cx_1 = null;
        else
          $this.cx_1 = cx;
        if (0 === (seen0 & 8))
          $this.cy_1 = null;
        else
          $this.cy_1 = cy;
        if (0 === (seen0 & 16))
          $this.radius_1 = null;
        else
          $this.radius_1 = radius;
        if (0 === (seen0 & 32))
          $this.fx_1 = null;
        else
          $this.fx_1 = fx;
        if (0 === (seen0 & 64))
          $this.fy_1 = null;
        else
          $this.fy_1 = fy;
        return $this;
      }
    }
    initMetadataForClass($, 'RadialGradient', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    RadialGradientClass = $;
  }
  return RadialGradientClass;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_4() {
  return Companion_instance_3;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.kiteui.models.FadingColor', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('base', false);
        tmp0_serialDesc.addElement_5pzumi_k$('alternate', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_91p5f9_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, $serializer_getInstance(), value.base_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance(), value.alternate_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_91p5f9_k$(encoder, value instanceof FadingColor() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, $serializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return FadingColor().new_com_lightningkite_kiteui_models_FadingColor_yjonvf_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [$serializer_getInstance(), $serializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var FadingColorClass;
function FadingColor() {
  if (FadingColorClass === VOID) {
    class $ {
      constructor(base, alternate) {
        this.base_1 = base;
        this.alternate_1 = alternate;
      }
      closestColor_akwbqu_k$() {
        return this.base_1;
      }
      map_p3tssl_k$(mapper) {
        return new (FadingColor())(mapper(this.base_1), mapper(this.alternate_1));
      }
      toString() {
        return 'FadingColor(base=' + this.base_1.toString() + ', alternate=' + this.alternate_1.toString() + ')';
      }
      hashCode() {
        var result = this.base_1.hashCode();
        result = imul(result, 31) + this.alternate_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FadingColor()))
          return false;
        if (!this.base_1.equals(other.base_1))
          return false;
        if (!this.alternate_1.equals(other.alternate_1))
          return false;
        return true;
      }
      static new_com_lightningkite_kiteui_models_FadingColor_yjonvf_k$(seen0, base, alternate, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_2().descriptor_1);
        }
        var $this = createThis(this);
        $this.base_1 = base;
        $this.alternate_1 = alternate;
        return $this;
      }
    }
    initMetadataForClass($, 'FadingColor', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
    FadingColorClass = $;
  }
  return FadingColorClass;
}
//region block: init
Companion_instance_1 = new (Companion_1())();
Companion_instance_3 = new (Companion_3())();
//endregion
//region block: exports
export {
  Color as Color17ck47lkedxoy,
  FadingColor as FadingColor3d6ef6zcqmlhk,
  GradientStop as GradientStoph1mm28b0oix,
  LinearGradient as LinearGradient2qftccjwl6uey,
  RadialGradient as RadialGradient3ic79yys0k1fp,
  applyAlpha as applyAlpha3k2fcxahu1lgz,
  Companion_getInstance_0 as Companion_getInstance2u620q9r4ejbj,
  Companion_getInstance_1 as Companion_getInstance1ily2eb07zh6i,
};
//endregion

//# sourceMappingURL=Paint.mjs.map
